// extracted by mini-css-extract-plugin
export default {"loading":"index_loading_2rPSM","loadingIcon":"index_loadingIcon_pmngg","rotate":"index_rotate_srjCU"};